export default "__VITE_ASSET__b67681e8__"